<script>
import lazyLoadComponent from '@router/lazyload-component'
const conditionList = (list) => {
  return list.filter(({condition})=>{
    if (condition) return condition()
    return true
  })
}

export default {
  data() {
    return {
      activeTab: '0',
      tabList: Object.freeze(conditionList([
        {
          title: '訂單',
          component: () => lazyLoadComponent(import('./DetailOrdersProduct')),
        },
        {
          title: `${this.$t('prepaid.BASE')}方案`,
          component: () => lazyLoadComponent(import('./DetailOrdersPrepaid')),
        },
        {
          title: '儲值訂單',
          component: () => lazyLoadComponent(import('./DetailOrdersDeposit')),
          condition: () => {
            return this.$hasDeposit()
          }
        },
      ])),
    }
  },
}
</script>

<template>
  <div :class="$style.page">
    <!-- <BasePageHeader title="預約紀錄">
      <template v-slot:right>
        <el-tabs v-model="activeTab" type="border-card" stretch class="isStyleBase">
          <el-tab-pane
            v-for="(tab, index) in tabList"
            :key="index"
            :label="tab.title"
            :name="`${index}`"
          ></el-tab-pane>
        </el-tabs>
      </template>
    </BasePageHeader> -->
    <el-tabs v-model="activeTab" type="border-card" stretch class="isStyleBase">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.title"
        :name="`${index}`"
      ></el-tab-pane>
    </el-tabs>
    <!-- <keep-alive> -->
      <component 
        :is="tabList[activeTab].component"
        :class="$style.pageContent"
      >
    </component>
    <!-- </keep-alive> -->
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
